"use client"

import * as React from "react"
import { Check } from "lucide-react"

import { cn } from "@/lib/utils"

export interface CheckboxProps extends React.InputHTMLAttributes<HTMLInputElement> {
  onCheckedChange?: (checked: boolean) => void
}

const Checkbox = React.forwardRef<HTMLInputElement, CheckboxProps>(
  ({ className, onCheckedChange, onChange, ...props }, ref) => (
    <span className={cn("relative inline-flex h-4 w-4", className)}>
      <input
        type="checkbox"
        ref={ref}
        className="peer absolute inset-0 h-full w-full cursor-pointer appearance-none rounded-sm"
        onChange={(event) => {
          onCheckedChange?.(event.target.checked)
          onChange?.(event)
        }}
        {...props}
      />
      <span
        className={cn(
          "pointer-events-none inline-flex h-full w-full items-center justify-center rounded-sm border border-input bg-background text-primary shadow transition-[background,border,box-shadow]",
          "peer-disabled:cursor-not-allowed peer-disabled:opacity-50",
          "peer-focus-visible:ring-2 peer-focus-visible:ring-ring peer-focus-visible:ring-offset-2",
          "peer-checked:border-primary peer-checked:bg-primary peer-checked:text-primary-foreground"
        )}
      >
        <Check className="h-3 w-3 opacity-0 transition-opacity peer-checked:opacity-100" />
      </span>
    </span>
  )
)

Checkbox.displayName = "Checkbox"

export { Checkbox }
